module.exports = __webpack_public_path__ + "static/img/third3.bbceeb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/third3.png
// module id = iE3b
// module chunks = 25